<template>
  <v-row class="mx-auto">
    <slot />
  </v-row>
</template>

<script>
  export default {
    props: {
      maxWidth: { type: Number, default: 1200 }
    },
    data: () => ({})
  }
</script>
